import { useQuery } from 'react-query';
import { getUserIdentities } from '../../services/userIdentities';

export function useGetUserIdentities() {
  return useQuery({
    queryKey: ['userIdentities'],
    queryFn: getUserIdentities
  });
}
